<template>
  <div class="row">
    <div class="col-lg-12" style="padding: 20px 0px 0px 20px">
      <div class="main-card mb-3 card">
        <div class="card-body">
          <div class="tab-content">
            <div id="home">
              <h5 class="card-title">
                {{ this.etc.board.title }}
                <div
                  class="sub_title"
                  style="
                    margin-bottom: 20px;
                    color: #333;
                    font-size: 13px;
                    border: 1px solid #ccc;
                    background: #f8f8f8;
                    height: 30px;
                    text-align: right;
                    position: absolute;
                    right: 20px;
                    top: 10px;
                    padding: 2px 10px;
                  "
                >
                  CAMPUS 게시판 → {{ this.etc.board.title }}
                </div>
              </h5>
              <p
                style="
                  font-size: 15px;
                  margin-top: 10px;
                  line-height: 25px;
                  color: #004279;
                  font-weight: 500;
                "
              >
                - 캠퍼스 홈페이지에 등록되는 배너(CAMPUS QUICK LINK)는
                <span style="font-weight: bold; color: red">최대 3개</span>까지
                등록 가능합니다.<br />
                - 등록 가능한이미지 형식은 jpg,png이며 이미지는 가로
                <span style="font-weight: bold; color: red"
                  >300px ,세로 150px</span
                >로 등록해주셔야합니다.<br />
                - 연결될 주소는 풀 주소로 넣어주시고,새로운 창으로 열립니다.
                ex)http://www.childu.co.kr/img/sample_img.png
              </p>

              <query-grid :config="config" ref="qg">
                <template #actions>
                  <router-link
                    to="articles/new"
                    v-if="this.$root.guiPerm == 'ROOT' || this.etc.is_writable"
                    ><button class="btn btn-danger">글쓰기</button></router-link
                  >
                </template>
                <template #items="props">
                  <tr v-for="article in props.records" v-bind:key="article.id">
                    <td style="text-align: center">
                      {{ article.businessesName }}
                    </td>
                    <td style="height: 48px">
                      <router-link
                        :to="
                          '/boards/' +
                          this.$route.params.board +
                          '/articles/' +
                          article.id
                        "
                        >{{ article.addi_data1 }} 번 배너</router-link
                      ><template v-if="article.tDiff < 8">
                        <span
                          style="
                            font-size: 10px;
                            margin-left: 2px;
                            font-weight: normal;
                            padding: 1px 4px 2px 4px;
                            background: #009cff;
                            color: #fff;
                            border-radius: 6px;
                          "
                          >NEW</span
                        >
                      </template>
                    </td>
                    <td style="height: 48px">{{ article.addi_data2 }}</td>
                    <td>{{ article.writerName }}</td>
                    <td>{{ article.created_at }}</td>
                  </tr>
                </template>
              </query-grid>

              <div style="float: right">
                <router-link to="articles/new" v-if="this.etc.is_writable"
                  ><button class="btn btn-danger">글쓰기</button></router-link
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Business from "../components/Business";
import QueryGrid from "../components/QueryGrid.vue";
export default {
  components: {
    QueryGrid,
    Business,
  },
  data: () => ({
    boards: {},
    etc: {
      board: {
        title: "",
      },
    },
    articles: [],
    selBoard: "",
    search: "",
    config: {
      name: "학습자료실",
      req_endpoint: "",
      default_limit: 20,
      no_excel: true,
      search_fields: [
        {
          id: "businesses",
          name: "소속선택",
          type: "business", // business, date, datetime,
        },
        {
          id: "date_filter",
          name: "날짜검색",
          type: "date",
          filter_type: {
            created_at: "등록일",
            updated_at: "수정일",
          },
        },
        {
          id: "search",
          name: "키워드검색",
          type: "text",
          placeholder: "제목으로 검색",
        },
      ],
      columns: [
        {
          id: "id",
          sortable: true,
          name: "캠퍼스",
          excel_print: (v) => {
            return v.id;
          },
        },
        {
          id: "addi_data1",
          sortable: true,
          name: "순번",
          excel_print: (v) => {
            return v.addi_data1;
          },
        },
        {
          id: "addi_data2",
          sortable: true,
          name: "링크",
          excel_print: (v) => {
            return v.addi_data2;
          },
        },
        {
          id: "writerName",
          sortable: true,
          name: "작성자",
          excel_print: (v) => {
            return v.writerName;
          },
        },
        {
          id: "created_at",
          sortable: true,
          name: "등록일",
          excel_print: (v) => {
            return v.created_at;
          },
        },
      ],
    },
  }),
  beforeMount() {
    if (!this.$route.params.board) {
      this.$route.params.board = "banner";
    }

    this.config.req_endpoint =
      "/boards/" + this.$route.params.board + "/articlesBanner";
    this.config.grid_parser = async (data) => {
      this.etc = data.etc;
      this.config.name = data.etc.board.title;
      return {
        records: data.result,
        total: data.total,
      };
    };
  },
  watch: {
    $route(to, from) {
      if (to !== from) {
        if (!this.$route.params.board) return;
        this.config.req_endpoint =
          "/boards/" + this.$route.params.board + "/articlesBanner";
        this.$refs.qg.search();
      }
    },
  },
};
</script>
